import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
export default function CopyRight() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright © '}
            <Link color="inherit" href="https://strideq.com/">
                StrideQ
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}
